var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconArrowDrop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 8,
    viewBox: "0 0 13 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.802919 0.969668C1.09581 0.676777 1.57069 0.676777 1.86358 0.969668L6.33325 5.4393L10.8029 0.969668C11.0958 0.676777 11.5707 0.676777 11.8636 0.969668C12.1565 1.26256 12.1565 1.73744 11.8636 2.0303L6.86355 7.0303C6.72295 7.171 6.53215 7.25 6.33325 7.25C6.13435 7.25 5.94355 7.171 5.80295 7.0303L0.802919 2.0303C0.510029 1.73744 0.510029 1.26256 0.802919 0.969668Z",
    fill: "#4B4B4B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowDrop);
export default __webpack_public_path__ + "static/media/iconArrowDrop.a64153bfd9efb87e738b333aa73d939a.svg";
export { ForwardRef as ReactComponent };